import { ProductJourneyPlace } from '../../lib/types/models/product/product-journey-place'
import { ProductJourneyPlaceInput } from '../../lib/types/models/product/product-journey-place-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createProductJourneyPlace = async (
  input: ProductJourneyPlaceInput & { productId: number }
) => {
  const { productId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.products.createProductJourneyPlace.url, { productId }))
    .post<ProductJourneyPlace, ProductJourneyPlaceInput>(data)
}
